import { toJS } from 'mobx'
import { DTO } from 'src/dto/DTO'

import { typeSafeAssign } from '@/utils/common'

// TODO: hanul - 고도화
export class UndoableDTO extends DTO {
  private past = []

  override update<T>(this: T, ...args: Partial<T>[]) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.past.push(toJS(this))
    super.update(...args)
    return this
  }

  override updateExceptNullable<T>(this: T, ...args: Partial<T>[]) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.past.push(toJS(this))
    super.update(...args)
    return this
  }

  undo() {
    if (this.past.length === 0) return

    const target = this.past.pop()
    typeSafeAssign(this, target)
  }
}
